/** 操作类型 */
export enum OperateType {
    /** 同步文档数据 */
    SyncDocument = 1,
    /** 同步文档更新时间 */
    SyncUpdateAt = 2,
    /** 同步舞台单位 */
    SyncUnit = 3,
    /** 自定义事件 */
    CustomEvent = 4,
    /** 同步基础信息 */
    SyncRenderIds = 5,
    /** 同步动态背景信息 */
    SyncDynamicBgInfo = 6,
    /** 同步图层 */
    SyncLayer = 7,
    /** 同步基础信息 */
    SyncBaseOperate = 8,

    /** 用户就绪 */
    UserReady = 100,
    /** 用户保存 */
    UserSave = 101,
    /** 舞台插入 */
    StageInsert = 102,
    /** 舞台插入等待 */
    StageInsertPending = 103,

    /** 用户选中图层 */
    PickLayer = 200,
    /** 移动光标 */
    MoveCursor = 201,
    /** 默认图层历史记录 */
    HistoryDefault = 202,
    /** 自定义图层历史记录 */
    HistoryCustom = 203,

    /** 移动 */
    Move = 300,
    /** 旋转 */
    Rotate = 301,
    /** 缩放 */
    Scale = 302,
    /** 调整尺寸 */
    Resize = 303,
    /** 自定义 */
    Custom = 304,
}
